<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/product-info" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Produkt-Information bearbeiten</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newCategoryForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6 form-div">
                <b-form-group>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Das label ist erforderlich',
                    }"
                  >
                    <v-text-field
                    :error-messages="errors[0]"
                      autocomplete="new-password"
                      v-model="form.featureName"
                      label="Label"
                      outlined
                    ></v-text-field>
                    <span>{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group>
                  <v-switch
                    v-model="status"
                    inset
                    :label="status == true ? 'Aktiviert' : 'Deaktiviert'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn
                    class="submit-btn-fill-outline"
                    @click="goToBack"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                  <!-- <br />
              <span class="form-errors" v-if="formError"
                >One or more fields has error. Please check form again.</span
              > -->
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="categories" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import Notifications from "vue-notification";
import HtmlClass from "@/core/services/htmlclass.service";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";

Vue.use(Notifications);
export default {
  name: "EditProductInformation",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.userId = localStorage.getItem("local_products_user_access_id");
      this.getInfoData();
    }
  },
  data() {
    return {
      formError: false,
      userId: null,
      formData: [],
      btnDisable: false,
      submitText: "Speichern",
      status: false,
      form: {
        featureName: null,
      },
      radioItems: [
        {
          key: "Enable",
          value: "1",
        },
        {
          key: "Disable",
          value: "0",
        },
      ],
    };
  },
  methods: {
    goToBack() {
      this.$router.push({ name: "product-info" });
    },
    getInfoData() {
      adminAPI
        .editProductInfo({ id: this.$route.params.id })
        .then((response) => {          
          if (response.status == "success") {
            this.form.featureName = response.data.lable;
            this.status = response.data.is_status == 1 ? true : false;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "categories",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "categories",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    onSubmit() {
      this.$refs.newCategoryForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.submitText = "Wird gespeichert...";
          let fd = new FormData();
          fd.append("lable", this.form.featureName);
          fd.append("id", this.$route.params.id);
          fd.append("status", this.status == true ? '1' : '0');
          setTimeout(() => {
            adminAPI
              .updateProductInfo(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.submitText = "Speichern"
                  this.btnDisable = false;
                  this.$notify({
                    group: "categories",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    this.$router.push({ name: "product-info" });
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Speichern";
                  this.$notify({
                    group: "categories",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Speichern";
                this.$notify({
                  group: "categories",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Speichern";
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
  .form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.remove-icon {
  cursor: pointer;
  position: absolute;
  top: 0;
}

.dropzone .dz-preview .dz-progress {
  /* progress bar covers file name */
  display: none !important;
  opacity: 0 !important;
}
</style>
